import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import CreateEdit from './CreateEdit';
import { useState, useEffect } from 'react';
import SnackbarAlert from '../common/SnackbarAlert';
import loader from '../common/loader.gif';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import PolicyBrokerageList from './PolicyBrokerageList';

function PolicyProductsBrokerage() {
  const [showCreateEdit, setShowCreateEdit] = useState(false);
  const [companyBranchEditDatas, setCompanyBranchEditDatas] = useState();
  const [editStatus, setEditStatus] = useState(false);
  const [editProdComDatas, setEditProdComDatas] = useState({});
  const [policyBrokerageViewPermission, setPolicyBrokerageViewPermission] =
    useState(false);
  const [isLoading, setLoading] = useState(true);

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const showCreateEditForm = () => {
    setShowCreateEdit(true);
  };
  const closeCreateEditForm = (status) => {
    setEditStatus(false);
    setCompanyBranchEditDatas(null);
    setShowCreateEdit(false);
    if (status) {
      setShowSnackBarAlert({
        status: true,
        type: 'success',
        message: 'Brokerage data updated'
      });
    }
  };


  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  useEffect(() => {
    checkRolePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('brokerageCalculation', 'view').then(
      (permission) => {
        setPolicyBrokerageViewPermission(permission);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      {showCreateEdit ? (
        <CreateEdit
          closeCreateEditForm={closeCreateEditForm}
          editProdComDatas={editProdComDatas}
          editStatus={editStatus}
        />
      ) : (
        <>
          <Container maxWidth="lg">
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={3}
            >
              <Grid item xs={12}>
                {policyBrokerageViewPermission ? (
                  <PolicyBrokerageList
                    setEditProdComDatas={setEditProdComDatas}
                    showCreateEditForm={showCreateEditForm}
                    showCreateEdit={showCreateEdit}
                  />
                ) : isLoading ? (
                  <img
                    alt="loader"
                    src={loader}
                    className="loader"
                    width={100}
                    height={100}
                  />
                ) : (
                  <NoPermissionContent />
                )}
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      <Footer />
    </>
  );
}

export default PolicyProductsBrokerage;
